import Vue from 'vue';
import L from 'leaflet';
import '@/plugins/vuetify';
import '@/plugins/storage';
import '@/plugins/axios';
import '@/plugins/socketio';
import config from '@/config';
import router from '@/plugins/router';
import store from '@/store';
import 'leaflet.icon.glyph';

import App from '@/App.vue';
import Err from '@/Err.vue';


delete L.Icon.Default.prototype._getIconUrl; // eslint-disable-line
Vue.config.productionTip = false;

const iconRetinaUrl = require('leaflet/dist/images/marker-icon-2x.png');
const iconUrl = require('leaflet/dist/images/marker-icon.png');
const shadowUrl = require('leaflet/dist/images/marker-shadow.png');

L.Icon.Default.mergeOptions({ iconRetinaUrl, iconUrl, shadowUrl });

config.mount(Vue.prototype, store)
  .then(() => {
    new Vue({
      store,
      router,
      render: h => h(App),
    }).$mount('#app');
  })
  .catch((err) => {
    Vue.prototype.currentError = err;

    new Vue({
      render: h => h(Err),
    }).$mount('#app');
  });
